import server from "@/plugins/http.js";

// 试玩
export function attemptPlay(params) {
    return server({
        url: '/api/app/activity/attempt/play',
        method: 'get',
        params: params,
    })
}
// 轮询
export function queryQueue(params) {
    return server({
        url: `/api/app/activity/query/queue/${params}`,
        method: 'get',
        //   params: params,
    })
}
// 退出
export function quieQueue(params) {
    return server({
        url: `/api/app/activity/quie/queue/${params}`,
        method: 'get',
        //   params: params,
    })
}
// 邀请注册并登录
export function registerV2(data) {
    return server({
        url: '/api/h5/activity/register/V2',
        method: 'post',
        data: data,
    })
}
// 查询剩余次数
export function queryplayCount(params) {
    return server({
        url: `/api/app/activity/query/playCount`,
        method: 'get',
        params: params,
    })
}

// 618活动列表
export function sixOneEightList(data) {
    return server({
        url: '/api/app/vip/getActivitySetMealListBySkuId',
        method: 'post',
        data: data,
    })
}

// 获取最新618拼团数据
export function massiveGroupBuyingData(params) {
    return server({
        url: `/api/app/group/booking/geTnewest618GroupBuyingData`,
        method: 'get',
        params: params,
    })
}
// 获取最新618拼团数据
export function massiveGroupAllPackageType(params) {
    return server({
        url: `/api/app/group/booking/get618GroupBuyingAllPackageType`,
        method: 'get',
        params: params,
    })
}


// 获取预定所有套餐
export function allReserveSetMenu(params) {
    return server({
        url: `/api/app/reserve/getAllReserveSetMenu`,
        method: 'get',
        params: params,
    })
}
// 获取预定所有套餐
export function userPaidDepositSetMenu(params) {
    return server({
        url: `/api/app/reserve/getUserPaidDepositSetMenu`,
        method: 'get',
        params: params,
    })
}